import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const uploadClaimingProfiles = async (validBrokers) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/upload-claiming-profile-records`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(validBrokers),
  });
  const data = await response.json();
  if (data.session) return handleSessionExpire();

  //  Show browser alert
  if (data.message) {
    alert(data.message);
  }

  return data;
};

const fetchClaimingProfiles = async (page, query) => {
  try {
    const sessionToken = getCookie();
    if(!sessionToken) return handleSessionExpire();

    const headers = {
      'Authorization': `Bearer ${sessionToken}`,
    };

    const response = await fetch(
      `${API_URL}/fetch-claiming-profiles/${page || '1'}/${query || undefined}`,
      {
        headers,
      }
    );
    const data = await response.json();
    return data;
  } catch {
    return false;
  }
};

const deleteClaimingProfiles = async (id) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(
    `${API_URL}/delete-claiming-profile-record/${id}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
    }
  );
  const data = await response.json();
  return data.session ? handleSessionExpire() : data;
};

const updateClaimingProfiles = async (updatedData) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/update-claiming-profile-record`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(updatedData),
  });
  const data = await response.json();
  return data.session ? handleSessionExpire() : data;
};

const addClaimingProfiles = async (newData) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/add-claiming-profile-record`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(newData),
  });
  const data = await response.json();
  return data.session ? handleSessionExpire() : data;
};

const uploadClaimingProfileImage = async (formData) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  try {
    const response = await fetch(`${API_URL}/claiming-profile-upload-image`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
      body: formData,
    });

    const data = await response.json();
    if (data.session) {
      handleSessionExpire();
      return;
    }

    return data;
  } catch (error) {
    console.error('Image upload failed:', error);
    throw error;
  }
};

const deleteClaimingProfileImage = async (profileId) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  try {
    const response = await fetch(`${API_URL}/claiming-profile-delete-image`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
      body: JSON.stringify({ profileId }),
    });

    const data = await response.json();
    if (data.session) {
      handleSessionExpire();
      return;
    }

    return data;
  } catch (error) {
    console.error('Image deletion failed:', error);
    throw error;
  }
};

export {
  uploadClaimingProfiles,
  fetchClaimingProfiles,
  deleteClaimingProfiles,
  updateClaimingProfiles,
  addClaimingProfiles,
  uploadClaimingProfileImage,
  deleteClaimingProfileImage,
};
